//form url (path-based gateway routing, restored from dev)
const fetchForm = "api/form-service/form/all";
const fetchTemplate = "api/form-service/formTemplates";
const formAction = "api/form-service/form";
const formPermission = "api/platform-service/config/permissionConfig/custom";
const publicFormAction = "api/form-service/public/form";
const formRule = "api/form-service/form/rules";
const fetchRuleAction = "api/form-service/public/form/rules/";
const fetchWorkflow = "api/form-service/bpmprocess/form/";
const deleteRuleAction = "api/form-service/form/rules/";
const formDashboard = "api/form-service/dashboard";
const formDashboardAction = "api/form-service/dashboard/";
const formAnalytic = "api/form-service/form/analytics";
const formAnalyticAction = "api/form-service/form/analytics/";
const formQuery = "api/form-service/query";
const formSubmissionQuery = "api/form-service/submission/query";
const getSubmissionCount = "api/form-service/form/analytics/count";
const getSubmissionsForLookup = "api/form-service/form/submission/field/";
const getSubmissionsForLookupByQuery = "api/form-service/v1/form/submission";
const publicFormSubmissionQuery = "api/form-service/public/submission/query";
const createWorkflow = "api/form-service/bpmprocess/create";

// folders urls (path-based gateway routing, restored from dev)
const fetchFolder = "api/form-service/folder";
const createFolder = "api/form-service/folder";
const updateFolder = "api/form-service/folder";
const deleteFolder = "api/form-service/folder";
const getFolderById = "api/form-service/folder";
const bulkUpdateFormFolderPath = "api/form-service/folder/bulk";

//auth url (path-based gateway routing, restored from dev)
const getUserPermissionDetails = "api/platform-service/users/getUserDetails";
const userLogin = "api/platform-service/users/login";
const userLogout = "api/platform-service/users/logout";
const userRefreshToken = "api/platform-service/users/refreshToken";
const userSignup = "api/platform-service/users/signup";
const forgotPassword = "api/platform-service/users/forgotPassword";

//submission url (path-based gateway routing, restored from dev)
const submission = "api/form-service/form/submission";
const bulkSubmission = "api/form-service/bulk/form/submission";
const updateBulkSubmission = "api/form-service/bulk/form/resubmission";
const checkDuplicate = "api/form-service/form/submission/checkDuplicate";
const publicCheckDuplicate = "api/form-service/public/form/submission/checkDuplicate";
const fetchSubmisison = "api/form-service/form/submission/respond";
const fetchSubmissionBySubmissionId = "api/form-service/form/submission/";
const formSubmissionsExport = "api/form-service/form/submission/export";
const deleteSubmission = "api/form-service/form/submission";
const sendOrValidateOTP = "api/otp/sendOrValidate";

//payment url (path-based gateway routing, restored from dev)
const addMerchant = `api/payment-service/merchantDetails/save`;
const getMerchant = `api/payment-service/merchantDetails/getAll/`;
const getMerchantById = `api/payment-service/merchantDetails/getAllDataByPaymentId`;
const refundAmountPath = `api/payment-service/payment/nttdata/refund/initiate`;
const subscriptions = `api/payment-service/subscriptions`;

//profile url (path-based gateway routing, restored from dev)
const fetchUserProfiles = `api/platform-service/users/all`;
const updateProfileData = `api/platform-service/users`;
const registerOrganization = `api/platform-service/admin/organization`;

//theme url (path-based gateway routing, restored from dev)
const saveFormData = `api/form-service/themeData/save`;
const getAllThemeData = `api/form-service/themeData/getUserThemes`;
const deleteThemeData = `api/form-service/themeData/deleteByThemeId`;
const getThemeData = `api/form-service/themeData/getTheme/`;
const getPublicThemeData = `api/form-service/public/themeData/getPublicTheme/`

//upload url (fetchProfilePic/uploadFormFile/uploadFormFiles use forms-service file/upload route, not docs-service)
const uploadProfilePic = `api/platform-service/users/uploadProfilePic`;
const fetchProfilePic = `api/form-service/file`;
const uploadFormFile = `api/form-service/file/upload`;
const uploadFormFiles = `api/form-service/file/upload`;
const uploadScormChunkFiles = `api/upload/chunk`;
const uploadScormChunkComplete = `api/upload/complete`;
const uploadFormFilesChunk = `api/file/chunk`;
const uploadComplete = `api/file/complete`;
const uploadScormFiles = `api/upload/zip`;
const uploadVideoFiles = `api/file/upload/blob`;
const uploadFormLogo = `api/form-service/file/uploads`;

//signature url
const getSignatureById = `api/form-service/public/sign`;

//Form Lock
const formLockAction = `api/form-service/form`;

//crafter-service
const getFilters = `api/crafter-service/filters`;

//admin/user urls
const getAdminUsers = `api/platform-service/admin/users`;
const getCustomizedUserData = `api/platform-service/admin/users/customizedUserData`;
const updateUserWithGroupsRoles = `api/platform-service/admin/users/updateUserWithGroupsRoles`;
const getOrganizationUserAttributes = `api/platform-service/admin/organization/details/userAttributes`;
export {
    fetchForm,
    fetchTemplate,
    formAction,
    formRule,
    fetchRuleAction,
    deleteRuleAction,
    formDashboard,
    formDashboardAction,
    formAnalytic,
    formAnalyticAction,
    formQuery,
    submission,
    checkDuplicate,
    fetchSubmisison,
    fetchSubmissionBySubmissionId,
    formSubmissionsExport,
    getSubmissionCount,
    addMerchant,
    getMerchant,
    getMerchantById,
    fetchUserProfiles,
    updateProfileData,
    registerOrganization,
    saveFormData,
    getAllThemeData,
    deleteThemeData,
    uploadProfilePic,
    fetchProfilePic,
    uploadFormFile,
    uploadFormFiles,
    uploadFormLogo,
    getUserPermissionDetails,
    publicFormAction,
    publicCheckDuplicate,
    fetchFolder,
    createFolder,
    updateFolder,
    deleteFolder,
    getFolderById,
    bulkUpdateFormFolderPath,
    getSubmissionsForLookup,
    formPermission,
    fetchWorkflow,
    getSubmissionsForLookupByQuery,
    formSubmissionQuery,
    publicFormSubmissionQuery,
    refundAmountPath,
    getSignatureById,
    createWorkflow,
    deleteSubmission,
    updateBulkSubmission,
    bulkSubmission,
    subscriptions,
    getThemeData,
    getPublicThemeData,
    uploadScormFiles,
    uploadFormFilesChunk,
    uploadComplete,
    uploadScormChunkFiles,
    uploadScormChunkComplete,
    uploadVideoFiles,
    sendOrValidateOTP,
    formLockAction,
    getFilters,
    userLogin,
    userLogout,
    userRefreshToken,
    userSignup,
    forgotPassword,
    getAdminUsers,
    getCustomizedUserData,
    updateUserWithGroupsRoles,
    getOrganizationUserAttributes
};
